import { OverlayConfig } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { ButtonPurpose } from '@mhe/ngx-shared/button';
import { TemplateUuids, isIframeClick, provideValueAccessor } from '@mhe/ngx-shared/utils';
import { format, isValid, parse } from 'date-fns';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatepickerCalendarComponent } from './datepicker-calendar.component';
import { DatepickerPosition } from './models';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/a11y";
import * as i2 from "./datepicker.options";
import * as i3 from "@angular/cdk/overlay";
import * as i4 from "@mhe/ngx-shared/translate";
import * as i5 from "@angular/common";
import * as i6 from "@mhe/ngx-shared/button";
import * as i7 from "@mhe/ngx-shared/required-indicator";
import * as i8 from "@mhe/ngx-shared/tooltip";
const _c0 = ["dateInputField"];
const _c1 = ["datepickerFormGroup"];
function DatepickerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1, 2)(2, "label", 3);
    i0.ɵɵtext(3);
    i0.ɵɵelementStart(4, "span", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "mhe-required-indicator", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 6)(8, "input", 7, 8);
    i0.ɵɵlistener("change", function DatepickerComponent_div_0_Template_input_change_8_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.onInputChange($event)); })("input", function DatepickerComponent_div_0_Template_input_input_8_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r5 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r5.onEveryInputChange($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "span", 9);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 10);
    i0.ɵɵlistener("click", function DatepickerComponent_div_0_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r4); const ctx_r6 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r6.toggleVisible()); });
    i0.ɵɵelement(13, "i", 11);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has-feedback", !ctx_r0.isValidDate)("has-error", !ctx_r0.isValidDate);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("for", ctx_r0.defaultFieldId);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("(", ctx_r0.dateFormat, ")");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r0.defaultFieldId);
    i0.ɵɵproperty("value", ctx_r0.value);
    i0.ɵɵattribute("disabled", ctx_r0.disabled || undefined)("aria-describedby", ctx_r0.ariaDescribedBy)("required", ctx_r0.required ? "" : null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", ctx_r0.ariaDescribedBy);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Enter a date in the format as ", ctx_r0.dateFormat, " or use the adjacent button to open a calendar. ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("mheTooltip", ctx_r0.datepickerTooltipMessage)("purpose", ctx_r0._buttonPurpose.Icon);
    i0.ɵɵattribute("disabled", ctx_r0.disabled || undefined);
} }
export class DatepickerComponent {
    constructor(liveAnnouncer, options, el, overlay, translateService, _changeDetectorRef) {
        this.liveAnnouncer = liveAnnouncer;
        this.options = options;
        this.el = el;
        this.overlay = overlay;
        this.translateService = translateService;
        this._changeDetectorRef = _changeDetectorRef;
        this.closeOnBlur = false;
        this.label = 'Date';
        this.value = '';
        this.dateFormat = 'MM/DD/YY';
        this.panelClass = '';
        this.disabled = false;
        this.isValidDate = true;
        this.position = DatepickerPosition.Bottom;
        this.dateChange = new EventEmitter();
        this.inputChange = new EventEmitter();
        this.isComponent = true;
        this.isOpened = false;
        this.error = false;
        this.locale = {}; // @todo UIK-105
        this._buttonPurpose = ButtonPurpose;
        this.SRDateFormat = 'D MMMM YYYY dddd';
        this.datepickerTooltipMessage = '';
        this._required = false;
        this.templateUuids = new TemplateUuids();
        this.destroy$ = new Subject();
        this._onChange = (_) => { };
        this._onTouch = () => { };
    }
    get required() {
        return this._required;
    }
    set required(value) {
        this._required = typeof value !== 'undefined' && value !== false;
    }
    ngOnInit() {
        if (!this.tooltipMessage) {
            this.translateService
                .translate('ngx-shared-open-calendar')
                .pipe(takeUntil(this.destroy$))
                .subscribe((msg) => (this.datepickerTooltipMessage = msg !== null && msg !== void 0 ? msg : ''));
        }
        else {
            this.datepickerTooltipMessage = this.tooltipMessage;
        }
    }
    onInputChange(event) {
        const { value } = event.target;
        if (isValid(parse(value))) {
            const dateChange = {
                date: parse(value),
                dateString: value,
                valid: true,
            };
            this.onDateChange(dateChange);
        }
        else {
            const dateChange = {
                date: null,
                dateString: value,
                valid: false,
            };
            this.onInvalidDateChange(dateChange);
        }
    }
    onEveryInputChange(event) {
        const { value } = event.target;
        this.inputChange.emit(value);
    }
    onDateChange(dateChange) {
        this.value = dateChange.dateString;
        this.dateChange.emit(dateChange);
        this.isValidDate = true;
        this._onChange(this.value);
        if (this.isOpened) {
            this.close();
        }
    }
    onInvalidDateChange(dateChange) {
        this.dateChange.emit(dateChange);
        this.value = dateChange.dateString;
        this.isValidDate = false;
    }
    get ariaDescribedBy() {
        return this.templateUuids.get('datepicker-calendar');
    }
    get defaultFieldId() {
        return this.templateUuids.get('datepicker');
    }
    toggleVisible() {
        if (this.isOpened) {
            this.close();
        }
        else {
            this.open();
        }
    }
    // @TODO i18n these strings UIK-263
    close() {
        this.liveAnnouncer.announce(`Date selected, ${format(this.value, this.SRDateFormat, this.locale)}`);
        this.dateInputField.nativeElement.focus();
        this.isOpened = false;
        if (this.componentRef) {
            this.componentRef.destroy();
        }
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
    }
    open() {
        const msg = this.value
            ? `Selected date, ${format(this.value, this.SRDateFormat, this.locale)}`
            : `Current date, ${format(new Date(), this.SRDateFormat, this.locale)}`;
        this.liveAnnouncer.announce(msg);
        this.isOpened = true;
        this.createDatepicker();
    }
    createDatepicker() {
        const overlayConfig = this.getOverlayConfig();
        this.overlayRef = this.overlay.create(overlayConfig);
        const containerPortal = new ComponentPortal(DatepickerCalendarComponent);
        this.componentRef = this.overlayRef.attach(containerPortal);
        this.componentRef.instance.dateFormat = this.dateFormat;
        this.componentRef.instance.innerValue = this.value;
        this.componentRef.instance.position = this.position;
        this.componentRef.instance.SRDateFormat = this.SRDateFormat;
        this.componentRef.instance.dateSelected
            .pipe(takeUntil(this.destroy$))
            .subscribe((event) => this.onDateChange(event));
        this.componentRef.instance.close.pipe(takeUntil(this.destroy$)).subscribe((_) => this.close());
        this.overlayRef.outsidePointerEvents().subscribe((event) => this.onClickedOutside(event));
        this.componentRef.changeDetectorRef.detectChanges();
    }
    getOverlayConfig() {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.datepickerFormGroup)
            .withPositions([{ originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' }]);
        const overlayConfig = new OverlayConfig({
            hasBackdrop: false,
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy,
            panelClass: this.panelClass,
        });
        return overlayConfig;
    }
    ngOnDestroy() {
        if (this.overlayRef) {
            this.overlayRef.dispose();
        }
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }
    onClickedOutside(event) {
        const target = event.target;
        if ((this.closeOnBlur && isIframeClick(event)) ||
            !this.el.nativeElement.contains(target) ||
            target.classList.contains('dpg-input-group') ||
            target === this.inputContainer.nativeElement) {
            this.close();
        }
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouch = fn;
    }
    writeValue(value) {
        if (value !== this.value) {
            if (isValid(parse(value))) {
                this.isValidDate = true;
                this.value = value;
                this._changeDetectorRef.markForCheck();
            }
            else {
                this.isValidDate = false;
            }
        }
    }
}
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(i0.ɵɵdirectiveInject(i1.LiveAnnouncer), i0.ɵɵdirectiveInject(i2.DatepickerOptions), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i3.Overlay), i0.ɵɵdirectiveInject(i4.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
DatepickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["mhe-datepicker"]], viewQuery: function DatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateInputField = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datepickerFormGroup = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputContainer = _t.first);
    } }, inputs: { closeOnBlur: "closeOnBlur", label: "label", value: "value", dateFormat: "dateFormat", panelClass: "panelClass", disabled: "disabled", isValidDate: "isValidDate", position: "position", tooltipMessage: "tooltipMessage", required: "required" }, outputs: { dateChange: "dateChange", inputChange: "inputChange" }, features: [i0.ɵɵProvidersFeature([provideValueAccessor(DatepickerComponent)])], decls: 1, vars: 1, consts: [["class", "ahe-ui form-group", 3, "has-feedback", "has-error", 4, "ngIf"], [1, "ahe-ui", "form-group"], ["datepickerFormGroup", ""], [3, "for"], ["aria-hidden", "true"], [3, "required"], [1, "dpg-input-group"], ["autocomplete", "off", 1, "form-control", 3, "id", "value", "change", "input"], ["dateInputField", ""], [1, "sr-only", 3, "id"], ["mhe-button", "", "placement", "right", 1, "dpg-input-group-btn", 3, "mheTooltip", "purpose", "click"], [1, "dpg-icon", "dpg-icon-calendar"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DatepickerComponent_div_0_Template, 14, 18, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.isComponent);
    } }, dependencies: [i5.NgIf, i6.MheButtonComponent, i7.RequiredIndicatorComponent, i8.TooltipDirective], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{ selector: 'mhe-datepicker', providers: [provideValueAccessor(DatepickerComponent)], template: "<div\n  *ngIf=\"isComponent\"\n  #datepickerFormGroup\n  class=\"ahe-ui form-group\"\n  [class.has-feedback]=\"!isValidDate\"\n  [class.has-error]=\"!isValidDate\"\n>\n  <label for=\"{{ defaultFieldId }}\">\n    {{ label }} <span aria-hidden=\"true\">({{ dateFormat }})</span>\n    <mhe-required-indicator [required]=\"required\"></mhe-required-indicator\n  ></label>\n\n  <div class=\"dpg-input-group\">\n    <input\n      #dateInputField\n      id=\"{{ defaultFieldId }}\"\n      autocomplete=\"off\"\n      class=\"form-control\"\n      [attr.disabled]=\"disabled || undefined\"\n      [attr.aria-describedby]=\"ariaDescribedBy\"\n      [attr.required]=\"required ? '' : null\"\n      [value]=\"value\"\n      (change)=\"onInputChange($event)\"\n      (input)=\"onEveryInputChange($event)\"\n    />\n\n    <span [id]=\"ariaDescribedBy\" class=\"sr-only\">\n      Enter a date in the format as {{ dateFormat }} or use the adjacent button to open a calendar.\n    </span>\n\n    <button\n      mhe-button\n      class=\"dpg-input-group-btn\"\n      placement=\"right\"\n      [attr.disabled]=\"disabled || undefined\"\n      [mheTooltip]=\"datepickerTooltipMessage\"\n      [purpose]=\"_buttonPurpose.Icon\"\n      (click)=\"toggleVisible()\"\n    >\n      <i class=\"dpg-icon dpg-icon-calendar\"></i>\n    </button>\n  </div>\n</div>\n", styles: ["/*# sourceMappingURL=datepicker.component.css.map */\n"] }]
    }], function () { return [{ type: i1.LiveAnnouncer }, { type: i2.DatepickerOptions }, { type: i0.ElementRef }, { type: i3.Overlay }, { type: i4.TranslateService }, { type: i0.ChangeDetectorRef }]; }, { closeOnBlur: [{
            type: Input
        }], label: [{
            type: Input
        }], value: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], panelClass: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isValidDate: [{
            type: Input
        }], position: [{
            type: Input
        }], tooltipMessage: [{
            type: Input
        }], required: [{
            type: Input
        }], dateChange: [{
            type: Output
        }], inputChange: [{
            type: Output
        }], dateInputField: [{
            type: ViewChild,
            args: ['dateInputField']
        }], datepickerFormGroup: [{
            type: ViewChild,
            args: ['datepickerFormGroup']
        }], inputContainer: [{
            type: ViewChild,
            args: ['dateInputField']
        }] }); })();
